import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import axios from 'axios'
import './validate'
import './numeral'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.min.css'
import 'bootstrap'

import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)

axios.defaults.baseURL = process.env.VUE_APP_API_URL + '/api/'
const token = localStorage.getItem('token')
if (token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
}


Vue.config.productionTip = false
new Vue({
    router,
    store,
    created: function () {
        axios.interceptors.response.use(undefined, function (err) {
            if (err.response.status === 401) {
                store.dispatch('interceptToken')
            }else {
                return Promise.reject(err);
            }
        });
    },
    render: h => h(App)
}).$mount('#app')
